import * as React from 'react';

import { useAtom, useAtomValue, useSetAtom } from 'jotai';

import { useExternalRoleCreateMutation } from './_graphql/useExternalRoleCreateMutation';

import { AddRoleDialogBase } from '~/modules/settings/_components/_shared';
import { externalPermissionModules } from '~/modules/settings/_generated/permissions';
import {
  $addExternalRoleDialogOpen,
  $addExternalRoleFormData,
  $addExternalRoleFormValid,
  $bulkUpdateAddExternalRolePermissions,
  $closeAddExternalRoleDialog,
  $updateAddExternalRoleForm,
  $updateAddExternalRolePermission,
} from '~/modules/settings/_state/addExternalRoleDialog.state';
import { useTranslations } from '~/modules/settings/i18n/useTranslations';

export const AddExternalRoleDialog = () => {
  const t = useTranslations();

  const [isOpen] = useAtom($addExternalRoleDialogOpen);
  const formData = useAtomValue($addExternalRoleFormData);
  const isFormValid = useAtomValue($addExternalRoleFormValid);
  const updateForm = useSetAtom($updateAddExternalRoleForm);
  const updatePermission = useSetAtom($updateAddExternalRolePermission);
  const bulkUpdatePermissions = useSetAtom(
    $bulkUpdateAddExternalRolePermissions,
  );
  const closeDialog = useSetAtom($closeAddExternalRoleDialog);

  const { mutateAsync: createRole, isPending } =
    useExternalRoleCreateMutation();

  const handlePermissionChange = React.useCallback(
    (key: string, enabled: boolean) => {
      updatePermission({ key, enabled });
    },
    [updatePermission],
  );

  const handleBulkPermissionChange = React.useCallback(
    (changes: Record<string, boolean>) => {
      bulkUpdatePermissions(changes);
    },
    [bulkUpdatePermissions],
  );

  return (
    <AddRoleDialogBase
      isOpen={isOpen}
      formData={formData}
      isFormValid={isFormValid}
      onUpdateName={(name) => updateForm({ name })}
      onPermissionChange={handlePermissionChange}
      onBulkPermissionChange={handleBulkPermissionChange}
      onClose={closeDialog}
      createRole={createRole}
      isCreatePending={isPending}
      permissionModules={externalPermissionModules}
      translations={t.customerPortal.roles.addRoleDialog}
      className="@AddExternalRoleDialog"
    />
  );
};
